(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/spelguide.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/spelguide.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Spelguide = Backbone.Marionette.View.extend({
    tabIdPrefix: 'tab-spelguide',
    template: function(data) {
      return svs.maltipset.templates.spelguide(data);
    },
    initialize: function() {
      this.setupTabs();
    },
    setupTabs: function() {
      var classNames = 'padding-1';
      this.tabViews = [];
      this.tabViews.push({
        caption: 'Om Måltipset',
        view: new Marionette.View({
          template: svs.maltipset.templates.spelguideabout,
          className: classNames
        }),
        id: this.tabIdPrefix + 'about'
      });

      this.tabViews.push({
        caption: 'Så här spelar du',
        view: new Marionette.View({
          template: svs.maltipset.templates.spelguidehowto,
          className: classNames
        }),
        id: this.tabIdPrefix + 'howto'
      });

      this.tabViews.push({
        caption: 'Vinstplan',
        view: new Marionette.View({
          template: svs.maltipset.templates.spelguidewinnings,
          className: classNames
        }),
        id: this.tabIdPrefix + 'winnings'
      });
    },
    onRender: function() {
      var self = this;

      this.renderTabs();

      this.tabView.on('onChange', function() {
        self.trigger('modalContentResize');
      });

      return this;
    },
    renderTabs: function() {
      this.tabView = new svs.components.Tabs({
        tabs: this.tabViews,
        el: this.$('#spelguide-tabview'),
        selected: this.getTabIdFromUrl(this.options.startTab)
      });
    },
    getTabIdFromUrl: function(tab) {
      switch (tab) {
        case '':
          return this.tabIdPrefix + 'about';
        case 'sa-har-spelar-du':
          return this.tabIdPrefix + 'howto';
        case 'vinstplan':
          return this.tabIdPrefix + 'winnings';
        default:
          return '';
      }
    }
  });
})(Backbone, _, svs);

 })(window);